import { CloseOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Spin,
} from 'antd'
import { runInAction } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { ButtonFooter } from '../../WorkPage/PopupWorkForm/PopupWorkFormStyled'
import ApprovalLevelCreate from './ApprovalLevelCreate'
import ApprovalTemplateSortableLevels from './ApprovalTemplateSortableLevels'
import {
  AddButton,
  ApprovalLevel,
  SelectOptionTemplate,
} from './ApproveTemplateStyled'
import validator from '../../../validator'

export const getInfoUser = (username, departmentWithUserList) => {
  const user = {
    full_name: username,
    image_id: null,
    username: username,
  }
  departmentWithUserList.forEach(department => {
    const userTarget = department.users.find(
      user => user.user_name === username
    )

    if (userTarget) {
      user.full_name = userTarget.name_uppercase || username
      user.image_id = userTarget.image_id
    }
  })
  return user
}

const ApprovalTemplateUpdate = props => {
  const [form] = Form.useForm()

  const [isVisibleLevelCreateModal, setIsVisibleLevelCreateModal] = useState(
    false
  )
  const [checkAddMore, setCheckAddMore] = useState(true)
  const {
    approvalTemplateStore,
    selectPeopleStore,
    authenticationStore,
  } = props

  const { originDepartmentWithUserList, companyCode } = selectPeopleStore
  const { approvalTemplateDetail } = approvalTemplateStore

  const [isUpdating, setIsUpdating] = useState(false)

  const [isLoading, setIsLoading] = useState(false)
  const [templateType, setTemplateType] = useState('')

  useEffect(() => {
    getApprovalTemplateDetail(props.templateId)

    return () => approvalTemplateStore.clearApprovalTemplateDetail()
  }, [props.templateId])

  useEffect(() => {
    form.setFieldsValue({
      name: approvalTemplateDetail.name,
      description: approvalTemplateDetail.description,
      template_type: approvalTemplateDetail.template_type,
    })

    setTemplateType(approvalTemplateDetail.template_type)

    runInAction(() => {
      approvalTemplateStore.approvalTemplateSortableLevels = approvalTemplateDetail.approval_levels
        .slice(1)
        .map(tempLevel => {
          const handler = getInfoUser(
            tempLevel.username,
            originDepartmentWithUserList
          )
          return {
            level: tempLevel.level,
            code: tempLevel.code,
            name: tempLevel.name,
            allow_edit: tempLevel.allow_edit,
            is_deleted: false,
            handler: {
              full_name: handler.full_name,
              username: handler.username,
            },
          }
        })
    })

    return () => approvalTemplateStore.clearApprovalTemplateSortableLevels()
  }, [approvalTemplateDetail])
  const [countLevelCreateModal, setCountLevelCreateModal] = useState(0)
  useEffect(() => {
    setCountLevelCreateModal(
      approvalTemplateStore.approvalTemplateSortableLevels.length
    )
  }, [approvalTemplateDetail])
  useEffect(() => {
    countLevelCreateModal >= 5 ? setCheckAddMore(false) : setCheckAddMore(true)
  }, [countLevelCreateModal])

  const getApprovalTemplateDetail = async id => {
    try {
      setIsLoading(true)
      await approvalTemplateStore.getApprovalTemplateDetail(id)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleToggleLevelCreateModal = bool => event => {
    setIsVisibleLevelCreateModal(bool)
    if (!bool) {
      selectPeopleStore.clearSelected()
    }
  }

  const onFinish = async value => {
    try {
      setIsUpdating(true)

      let level = 0

      if (
        approvalTemplateStore.approvalTemplateSortableLevels.filter(
          level => !level.is_deleted
        ).length === 0
      ) {
        message.error('Số cấp duyệt phải từ 1 cấp trở lên')
        return
      }

      const approvalTemplate = {
        name: value.name.replace(/\s+/g, ' ').trim(),
        description: value.description.trim(),
        template_type: value.template_type,
        approval_levels: [
          approvalTemplateStore.approvalTemplateDetail.approval_levels[0],
          ...approvalTemplateStore.approvalTemplateSortableLevels.map(
            approvalLevel => {
              if (!approvalLevel.is_deleted) level += 1

              return {
                code: approvalLevel.is_temp ? null : approvalLevel.code,
                level: approvalLevel.is_deleted ? approvalLevel.level : level,
                name: approvalLevel.name.replace(/\s+/g, ' ').trim(),
                allow_edit: approvalLevel.allow_edit,
                username: approvalLevel.handler?.username,
                is_deleted: approvalLevel.is_deleted,
              }
            }
          ),
        ],
      }

      await approvalTemplateStore.updateApprovalTemplate(
        props.templateId,
        approvalTemplate
      )
      message.success('Chỉnh sửa cấp duyệt thành công')
      props.onCancel()
      await approvalTemplateStore.getApprovalTemplateLists()
    } catch (error) {
      console.log(error)
      message.error('Chỉnh sửa cấp duyệt không thành công')
      props.onCancel()
    } finally {
      setIsUpdating(false)
    }
  }

  const changeTypeName = type => {
    switch (type) {
      case 'asset':
        return 'Văn phòng phẩm'
      case 'proposal':
        return 'Hành chính'
      case 'salary':
        return 'Duyệt lương'
      default:
        return ''
    }
  }
  const handleTemplateTypeChange = value => {
    setTemplateType(value)
  }

  return (
    <>
      <Form onFinish={onFinish} form={form} layout="vertical">
        <Spin spinning={isLoading}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              {/* <Form.Item
                label={'Loại cấp duyệt:'}
                name={'template_type'}
                disabled>
                <SelectOptionTemplate
                  defaultValue={changeTypeName(
                    approvalTemplateStore?.approvalTemplateDetail?.template_type
                  )}
                  style={{ width: '100%' }}
                  disabled
                  options={[
                    {
                      value:
                        approvalTemplateStore?.approvalTemplateDetail
                          ?.template_type,
                      label: changeTypeName(
                        approvalTemplateStore?.approvalTemplateDetail
                          ?.template_type
                      ),
                    },
                  ]}
                />
              </Form.Item> */}
              <Form.Item
                label={'Loại cấp duyệt:'}
                name={'template_type'}
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng chọn loại cấp duyệt!',
                  },
                ]}>
                <Select
                  className="h-40"
                  placeholder={'Chọn loại cấp duyệt'}
                  allowClear
                  onChange={handleTemplateTypeChange}
                  value={templateType}
                  style={{ width: '100%' }}>
                  <Option value={'asset'}>Văn Phòng Phẩm</Option>
                  <Option value={'proposal'}>Hành chính</Option>
                  <Option value={'salary'}>Duyệt lương</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label={'Tên:'}
                name={'name'}
                rules={[
                  { required: true, message: 'Vui lòng nhập tên cấp duyệt' },
                  {
                    max: 500,
                    message: 'Tên cấp duyệt không được dài quá 500 ký tự!',
                  },
                  { validator: validator.validateInputString },
                ]}>
                <Input placeholder={'Nhập tên cấp duyệt...'} className="h-40" />
              </Form.Item>

              <Form.Item
                name={'description'}
                label={'Mô tả:'}
                rules={[
                  { required: true, message: 'Vui lòng nhập mô tả cấp duyệt!' },
                  { validator: validator.validateInputString },
                ]}>
                <Input.TextArea rows={4} placeholder={'Nhập mô tả cấp duyệt'} />
              </Form.Item>
            </Col>

            <Col span={16}>
              <p style={{ fontWeight: 500, marginBottom: 8 }}>Cấp độ duyệt</p>

              <ApprovalLevel>
                <Row style={{ justifyContent: 'flex-end', marginBottom: 0 }}>
                  <Col span={22} className="approval-level__content">
                    <dt>Tên</dt>
                    <dd>Bộ phận đề nghị</dd>
                    <dt>Người xử lý</dt>
                    <dd>Mặc định</dd>
                  </Col>
                </Row>
              </ApprovalLevel>

              <ApprovalTemplateSortableLevels
                countLevelCreateModal={countLevelCreateModal}
                setCountLevelCreateModal={setCountLevelCreateModal}
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {checkAddMore ? (
                  <Button
                    type="link"
                    onClick={handleToggleLevelCreateModal(true)}>
                    Thêm cấp duyệt
                  </Button>
                ) : (
                  <div style={{ color: 'red', textAlign: 'right' }}>
                    * Đã đạt mức tối đa 5 cấp duyệt
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Spin>
        <ButtonFooter>
          <Space>
            <Button
              className="custom-ant-button"
              danger
              onClick={props.onCancel}>
              Đóng
            </Button>
            <Button
              className="custom-ant-button"
              type={'primary'}
              htmlType={'submit'}
              loading={isUpdating}>
              Lưu
            </Button>
          </Space>
        </ButtonFooter>
      </Form>

      <Modal
        width={800}
        wrapClassName="custom-modal-wrapper"
        title={'Thêm cấp duyệt'}
        visible={isVisibleLevelCreateModal}
        maskClosable={false}
        onCancel={handleToggleLevelCreateModal(false)}
        footer={null}
        destroyOnClose>
        {isVisibleLevelCreateModal && (
          <ApprovalLevelCreate
            onCancel={handleToggleLevelCreateModal(false)}
            countLevelCreateModal={countLevelCreateModal}
            setCountLevelCreateModal={setCountLevelCreateModal}
          />
        )}
      </Modal>
    </>
  )
}
export default inject(
  'approvalTemplateStore',
  'selectPeopleStore',
  'authenticationStore'
)(observer(ApprovalTemplateUpdate))
